/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterOptionsIntegratedToolAccount {
    getFixupPrototypeFunction() { return FilterOptionsIntegratedToolAccount.fixupPrototype; }

    static newInstance(model: Partial<FilterOptionsIntegratedToolAccount>): FilterOptionsIntegratedToolAccount {
        let obj = Object.assign(new FilterOptionsIntegratedToolAccount(), model);
        FilterOptionsIntegratedToolAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterOptionsIntegratedToolAccount>): FilterOptionsIntegratedToolAccount {
        if (!model) return null;
        return FilterOptionsIntegratedToolAccount.newInstance(<FilterOptionsIntegratedToolAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterOptionsIntegratedToolAccount) {
        if (!obj) return;

        models.FilterOptionsIntegratedToolAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterOptionsIntegratedToolAccount): boolean {
        Object.setPrototypeOf(obj, FilterOptionsIntegratedToolAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Indicates the status of the cloud account in corestack
     */
    status: models.ServiceAccountStatus;

    /**
     * Type of the integrated tool
     */
    tool_type: string;

    /**
     * ID of the account
     */
    tool_account_id: string;

    /**
     * Name of the account
     */
    tool_account_name: string;

    /**
     * Scope of the Integrated Tool account
     */
    scope: models.ServiceAccountScope;

}
